import { useEffect } from 'react';
import realtimeClient from '../services/realtimeClient';

/**
 * Custom React hook for real-time entity updates.
 * Automatically subscribes to entity mutation events (banners, products, categories, etc.)
 * and unsubscribes on component unmount.
 *
 * @param {string} entity - The entity to listen for (e.g. 'banners', 'products', 'categories')
 * @param {function} onMutation - Callback function invoked when a mutation event is received
 */
export function useRealtimeSync(entity, onMutation) {
  useEffect(() => {
    const unsubscribe = realtimeClient.subscribe(entity, onMutation);
    return () => unsubscribe();
  }, [entity, onMutation]);
}

export default useRealtimeSync;
